import React, { useEffect, useState } from "react";
import "./MainContent.css";
import ListTemplate from "./ListTemplate";
import { InlineStyle, Template, TemplateColumn } from "./interfaces/template.interface";

interface MainContentProps {
  template: Template;
  onCellClick: (col: TemplateColumn) => void;
  onBodyRowClick: (index: number) => void;
  updateTemplate: (template: Template) => void;
  onItemClick: (rowIndex: number, isHeader: boolean, col: TemplateColumn, field: string, styles: any[]) => void;
  onRemarkCellClick: (styles: InlineStyle[], key: string) => void;
  onPageClick: () => void;
  animationDirection: string;
  flipSpeed: string;
}

const MainContent: React.FC<MainContentProps> = ({ template, onPageClick, onItemClick, onBodyRowClick, onCellClick, updateTemplate, onRemarkCellClick, animationDirection, flipSpeed }) => {

  const handleItemClick = (rowIndex: number, isHeader: boolean, col: any, field: string, styles: any[]) => {
    onItemClick(rowIndex,isHeader, col, field, styles);
  };

  useEffect(() => {
    // Define your styles array
    const styles = template?.draft?.body?.inLineStyle as [];

    // Apply styles to the body tag
    const main = document.getElementById("main");
    const applyBodyStyles = (styleArray: any) => {
      styleArray && styleArray.forEach((style: any) => {
        if (main) main.style[style.prop] = style.value;
      });
    };

    // Call this function in a useEffect to ensure it runs after the component mounts
    applyBodyStyles(styles);

    // Optional cleanup to reset styles when the component unmounts
    return () => {
      styles && styles.forEach((style: any) => {
        if (main) main.style[style.prop] = "";
      });
    };

  }, [template]);

  return (
    <main id="main" className="main-content">
      <div className="x-scroll-container">
        {template && (<ListTemplate
          onPageClick={onPageClick}
          onRemarkCellClick={onRemarkCellClick}
          updateTemplate={updateTemplate}
          onCellClick={onCellClick}
          onBodyRowClick={onBodyRowClick}
          onItemClick={handleItemClick}
          template={template}
          animationDirection={animationDirection}
          flipSpeed={flipSpeed} />)}
      </div>
    </main>
  );
};

export default MainContent;
